import { useThree } from '@react-three/fiber'
import { useCallback, useEffect } from 'react'

import { GLTFObject } from '@/lib/cad/GLTFObject'
import { BACKSIDE_LAYER } from '@/pages/CADPage/constants'
import { SectionState, useCADPageStore } from '@/state/cad'
import { useAssemblyTreeQuery } from '@/pages/CADPage/queries'
import { useGetInclusiveGroupIds } from '@/services/hooks/steps'

export const useCrossSection = (gltf?: GLTFObject) => {
  const inclusiveGroupIds = useGetInclusiveGroupIds()

  const camera = useThree((state) => state.camera)
  const planes = useCADPageStore((state) => state.clippingPlanes)
  const sectioning = useCADPageStore((state) => state.sectionState)
  const {
    data: { assemblyTree },
  } = useAssemblyTreeQuery()

  const activeClippingPlane = 0

  const updateCrossSectionMap = useCallback(() => {
    if (!assemblyTree) return

    const parts = assemblyTree.nodes.map((node) => node.uuid)

    const { exclusiveCrossSectionMap } = useCADPageStore.getState()

    // Inclusive parts list
    const includedParts =
      inclusiveGroupIds && inclusiveGroupIds.length > 0
        ? inclusiveGroupIds
        : parts

    // Exclusive parts list
    const excludedParts = parts.filter((part) => !includedParts.includes(part))
    exclusiveCrossSectionMap[activeClippingPlane] = excludedParts

    useCADPageStore.setState({ exclusiveCrossSectionMap })
  }, [assemblyTree, inclusiveGroupIds])

  useEffect(() => {
    if (sectioning === SectionState.ENABLED) updateCrossSectionMap()
  }, [planes, sectioning, inclusiveGroupIds, updateCrossSectionMap])

  useEffect(() => {
    if (sectioning === SectionState.ENABLED) {
      camera.layers.disable(BACKSIDE_LAYER)
    } else if (sectioning === SectionState.RESET) {
      camera.layers.disable(BACKSIDE_LAYER)
    }
  }, [sectioning, camera, gltf])

  return updateCrossSectionMap
}
